import { gql, useMutation } from "@apollo/client";

import {
  AddSKUInput,
  AddSKUMutation,
  AddSKUMutationVariables,
} from "../../../../../API";
import { ADD_SKU } from "../../../../../common/operations/mutations";
import { successNotification } from "../../../../../common/variables/notification";
import { handleApolloError } from "../../../../../common/utils/handleApolloError";

export const useCreateSKU = () => {
  const [saveSKU, { data, loading }] = useMutation<
    AddSKUMutation,
    AddSKUMutationVariables
  >(ADD_SKU);

  const createSKU = (input: AddSKUInput) => {
    return saveSKU({
      variables: {
        input,
      },
      onCompleted: response => {
        if (response.addSKU) {
          successNotification("SKU created successfully");
        }
      },
      onError: handleApolloError,
      update: (cache, response): void => {
        cache.modify({
          fields: {
            getSKUs(existing) {
              const newSKURef = cache.writeFragment({
                data: response.data?.addSKU,
                fragment: gql`
                  fragment NewSKU on SKU {
                    id
                    skuNumber
                    configurationName
                    nodeCount
                    skuDataConfigurations
                    createdAt
                    defaultIp
                  }
                `,
              });

              if (!existing) {
                return response?.data;
              }

              return {
                ...existing,
                items: [newSKURef, ...existing.items],
              };
            },
          },
        });
      },
    });
  };

  return { createSKU, data, loading };
};
